/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { memo, useEffect, useMemo, useState } from 'react';
import useCurrency from 'hooks/useCurrency';
import REPAIR_TYPE from 'shared/repairTypeList';
import CURRENCY_TYPE from 'shared/currencyTypeList';
import { formatMultiplies, formatSingle } from 'utils/formatOddDecimal';
import OldDesign from './OldDesign';
import NewDesign from './NewDesign';

const CalculationByHomeData = ({
  homeData = {},
  homesData = [],
  order = 0,
  setData = () => {},
  formik,
  applyDiscount,
  setApplyDiscount,
  selectedDiscount,
  setSelectedDiscount,
  designType = 'old',
  currency,
  filters,
  setFilters,
}) => {
  const [fullPrice, setFullPrice] = useState(0);
  const [isrepaired, setIsrepaired] = useState(homeData?.isrepaired);
  const [sellPrice, setSellPrice] = useState(0);
  const [startPrice, setStartPrice] = useState(0);
  const [startPriceTopOrder, setStartPriceTopOrder] = useState(false);
  const [startPricePercentage, setStartPricePercentage] = useState(
    homeData?.start
  );

  const [priceForSquare, setPriceForSquare] = useState(
    homeData?.isrepaired == REPAIR_TYPE.REPAIRED.code
      ? homeData?.repaired
      : homeData?.norepaired
  );
  const [terassaPriceForSquare, setTerassaPriceForSquare] = useState(
    homeData?.isrepaired == REPAIR_TYPE.REPAIRED.code
      ? Number(homeData?.terassa_price_repaired)
      : Number(homeData?.terassa_price)
  );
  const square = homeData.square;
  const [discount, setDiscount] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [percent, setPercent] = useState(17.5);
  const [isEnableCalc, setIsEnableCalc] = useState(false);
  const [month, setMonth] = useState(29);
  const [priceForMonth, setPriceForMonth] = useState(0);
  // const [currency, setCurrency] = useState(
  //   homeData?.isvalute || CURRENCY_TYPE.SUM.code
  // );

  const { currencyData } = useCurrency();

  const handleChangeMonth = (value) => {
    setMonth(parseInt(value));
    setPriceForMonth(formatSingle((sellPrice - startPrice) / parseInt(value)));
  };

  const handleChangeStartPrice = (value) => {
    setStartPrice(value);
    setStartPricePercentage(
      sellPrice
        ? formatSingle(
            (value * 100) / (startPriceTopOrder ? fullPrice : sellPrice),
            3
          )
        : 0
    );
    setPriceForMonth(
      formatSingle(
        ((startPriceTopOrder ? fullPrice : sellPrice) - value) / month
      )
    );
  };

  const handleChangeStartPricePercent = (value) => {
    const startPrice =
      ((startPriceTopOrder ? fullPrice : sellPrice) * value) / 100;
    setStartPrice(startPrice);
    setStartPricePercentage(value);
    setPriceForMonth(formatSingle((sellPrice - startPrice) / month));
  };

  const handleChangeStartPriceOrder = (value) => {
    const startPrice =
      value && startPricePercentage < 100
        ? (startPricePercentage * fullPrice) / 100
        : (startPricePercentage * sellPrice) / 100;

    setStartPrice(startPrice);
    setPriceForMonth(formatSingle((sellPrice - startPrice) / month) || 0);
    setStartPriceTopOrder(value);
  };

  useEffect(() => {
    if (currencyData && currencyData.sum) {
      if (currency == CURRENCY_TYPE.VALUTE.code) {
        setFullPrice(fullPrice / currencyData.sum);
        setSellPrice(sellPrice / currencyData.sum);
        setDiscount(discount / currencyData.sum);
        setStartPrice(startPrice / currencyData.sum);
        setPriceForMonth(priceForMonth / currencyData.sum);
        setPriceForSquare(priceForSquare / currencyData.sum);
      } else {
        setFullPrice(fullPrice * currencyData.sum);
        setSellPrice(sellPrice * currencyData.sum);
        setDiscount(discount * currencyData.sum);
        setStartPrice(startPrice * currencyData.sum);
        setPriceForMonth(priceForMonth * currencyData.sum);
        setPriceForSquare(priceForSquare * currencyData.sum);
      }
    }
  }, [currency, currencyData.sum]);

  const handleChangeSellPrice = (newSellPrice) => {
    if (newSellPrice <= fullPrice) {
      const discount = fullPrice - newSellPrice;
      setDiscount(discount);
      setDiscountPercentage(
        fullPrice ? formatSingle((discount * 100) / fullPrice, 2) : 0
      );
      setSellPrice(newSellPrice);
      setPriceForMonth(formatSingle((newSellPrice - startPrice) / month));
      let newSellP = newSellPrice;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice =
          isrepaired == REPAIR_TYPE.REPAIRED.code
            ? Number(homeData?.terassa_price_repaired)
            : Number(homeData?.terassa_price);
        newSellP -= formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      setPriceForSquare(formatSingle(newSellP / square));
    }
  };

  const handleChangeDiscount = (disc) => {
    const newDisc = disc || 0;
    if (newDisc <= fullPrice) {
      const newStartPrice =
        (startPricePercentage *
          (fullPrice - (startPriceTopOrder ? 0 : newDisc))) /
        100;
      if (startPricePercentage) {
        setStartPrice(newStartPrice);
      }
      setDiscount(newDisc);
      setDiscountPercentage(
        fullPrice ? formatSingle((newDisc * 100) / fullPrice, 2) : 0
      );
      setSellPrice(() => fullPrice - newDisc);
      if (month == 0) {
        setPriceForMonth(0);
      } else
        setPriceForMonth(
          formatSingle((fullPrice - newDisc - newStartPrice) / month)
        );
      let newSellP = fullPrice;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice =
          isrepaired == REPAIR_TYPE.REPAIRED.code
            ? Number(homeData?.terassa_price_repaired)
            : Number(homeData?.terassa_price);
        newSellP -= formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      setPriceForSquare(formatSingle((newSellP - newDisc) / square));
    }
  };

  const handleChangeDiscountPercentage = (per) => {
    const newPer = per / 100 || 0;
    if (newPer * fullPrice <= fullPrice) {
      const newStartPrice =
        (fullPrice *
          startPricePercentage *
          (1 - (startPriceTopOrder ? 0 : newPer))) /
        100;
      if (startPricePercentage) {
        setStartPrice(newStartPrice);
      }
      setDiscount(newPer * fullPrice);
      setDiscountPercentage(per);
      setSellPrice(() => fullPrice * (1 - newPer));
      if (month == 0) {
        setPriceForMonth(0);
      } else
        setPriceForMonth(
          formatSingle((fullPrice - newPer * fullPrice - newStartPrice) / month)
        );
      let newSellP = fullPrice;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice =
          isrepaired == REPAIR_TYPE.REPAIRED.code
            ? Number(homeData?.terassa_price_repaired)
            : Number(homeData?.terassa_price);
        newSellP -= formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      setPriceForSquare(formatSingle((newSellP - newPer * fullPrice) / square));
    }
  };

  const handleChangePriceSquare = (newPriceForSquare) => {
    const currPriceByRepaired =
      isrepaired == REPAIR_TYPE.REPAIRED.code
        ? parseFloat(homeData?.repaired)
        : parseFloat(homeData?.norepaired);

    const maxPrice =
      homeData?.isvalute == CURRENCY_TYPE.SUM.code &&
      currency == CURRENCY_TYPE.VALUTE.code
        ? currPriceByRepaired / currencyData.sum
        : homeData?.isvalute == CURRENCY_TYPE.VALUTE.code &&
          currency == CURRENCY_TYPE.SUM.code
        ? currPriceByRepaired * currencyData.sum
        : currPriceByRepaired;

    if (newPriceForSquare <= maxPrice) {
      const newDiscount = formatMultiplies(
        [maxPrice - newPriceForSquare, homeData?.square],
        2
      );
      setDiscount(newDiscount);
      setDiscountPercentage(formatSingle((newDiscount * 100) / fullPrice, 2));
      let newSellP = formatMultiplies([newPriceForSquare, homeData?.square], 2);
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice =
          isrepaired == REPAIR_TYPE.REPAIRED.code
            ? Number(homeData?.terassa_price_repaired)
            : Number(homeData?.terassa_price);
        newSellP += formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      setSellPrice(newSellP);
      setPriceForMonth(
        formatSingle((startPriceTopOrder ? fullPrice : newSellP) - startPrice) /
          month,
        2
      );
      setPriceForSquare(newPriceForSquare);
    }
  };

  const handleChangeTerassaPriceSquare = (newPriceForSquare) => {
    // for future use if needed
  };

  useEffect(() => {
    if (!applyDiscount) {
      let sellP =
        isrepaired == REPAIR_TYPE.REPAIRED.code
          ? homeData?.repaired && homeData?.square
            ? formatMultiplies([homeData.repaired, homeData.square], 2)
            : 0
          : homeData?.norepaired && homeData?.square
          ? formatMultiplies([homeData.norepaired, homeData.square], 2)
          : 0;
      if (
        Number(homeData?.terassa) &&
        (Number(homeData?.terassa_price) ||
          Number(homeData?.terassa_price_repaired))
      ) {
        const terassaPrice =
          isrepaired == REPAIR_TYPE.REPAIRED.code
            ? Number(homeData?.terassa_price_repaired)
            : Number(homeData?.terassa_price);
        sellP += formatMultiplies([terassaPrice, homeData?.terassa], 2);
      }
      if (homeData?.isvalute != currency) {
        if (currency == CURRENCY_TYPE.VALUTE.code) {
          sellP = sellP / currencyData.sum;
        } else {
          sellP = sellP * currencyData.sum;
        }
      }

      setFullPrice(sellP);
      setSellPrice(sellP);
      setMonth(homeData?.blocks?.month || month);
      // setIsrepaired(isrepaired || month);
      setDiscount(0);
      setDiscountPercentage(0);
      setPriceForMonth(
        formatSingle(
          (sellP - formatSingle((sellP * +homeData?.start) / 100, 2)) /
            (homeData?.blocks?.month || month)
        )
      );
      setStartPrice(formatSingle((sellP * +homeData?.start) / 100, 2));
      setStartPricePercentage(homeData?.start);
      setPriceForSquare(
        isrepaired == REPAIR_TYPE.REPAIRED.code
          ? homeData?.repaired
          : homeData?.norepaired
      );
    }
  }, [applyDiscount, isrepaired, isrepaired]);

  useEffect(() => {
    const terassasum =
      Number(homeData?.terassa) && terassaPriceForSquare
        ? formatMultiplies([homeData?.terassa, terassaPriceForSquare], 2)
        : 0;

    setData({
      isvalute: currency,
      fullPrice,
      sellPrice,
      startPrice,
      startPricePercentage,
      month: month == 1 ? 0 : month,
      isrepaired,
      priceForMonth,
      priceForSquare,
      terassasum,
      discount,
      discountPercentage,
    });
  }, [
    order,
    currency,
    fullPrice,
    sellPrice,
    startPrice,
    startPricePercentage,
    month,
    priceForMonth,
    priceForSquare,
    discount,
    isrepaired,
    discountPercentage,
  ]);

  const handleChange = (e) => {
    setIsrepaired(e?.target?.value);
  };

  useEffect(() => {
    if (startPricePercentage == 100) {
      setMonth(1);
    } else if (!month) {
      // setMonth(homeData?.blocks.month || 24);
      // setPriceForMonth(
      //   formatSingle(
      //     ((startPriceTopOrder ? fullPrice : sellPrice) - startPrice) /
      //       parseInt(homeData?.blocks.month || 24)
      //   )
      // );
      setPriceForMonth(0);
    }
  }, [
    startPricePercentage,
    homeData?.blocks.month,
    sellPrice,
    startPrice,
    month,
    startPriceTopOrder,
    fullPrice,
  ]);

  useEffect(() => {
    if (!applyDiscount && formik.values.discountId) {
      setApplyDiscount(true);
    }
  }, [formik.values.discountId]);

  const calculations = useMemo(() => {
    const amount = sellPrice - startPrice;

    const monthlyRate = percent / 100 / 12;

    const annuityFactor =
      (monthlyRate * Math.pow(1 + monthlyRate, month)) /
      (Math.pow(1 + monthlyRate, month) - 1);

    const monthlyPayment =
      amount * annuityFactor * (currency == 1 ? currencyData?.sum : 1);
    const totalPayment = monthlyPayment * month;

    return {
      totalPayment: totalPayment.toFixed(2),
      monthlyPayment: monthlyPayment.toFixed(2),
    };
  }, [sellPrice, startPrice, percent, currency, currencyData?.sum, month]);

  return (
    <div className='calculation-wrapper !border-none !p-0'>
      <div>
        <div className='home-details-header !items-center fixed right-36 top-2'>
          {/* {t('shaxmatka.moreHomeDetails.selectedHomes')} */}
          {/* <div className='currency-data'>
            {currency == CURRENCY_TYPE.VALUTE.code && (
              <div className='mr-2 whitespace-nowrap'>
                {t('common.fields.currency')}:{' '}
                <NumericFormat
                  value={currencyData?.sum}
                  allowNegative={false}
                  displayType={'text'}
                  thousandSeparator={' '}
                  decimalScale={1}
                  className='w-full text-right'
                  suffix=' UZS'
                />
              </div>
            )}
            <SimpleToggleButtonGroup
              delay={0}
              duration={0}
              value={currency?.toString()}
              changeFn={handleCurrencyTypeChange}
              options={currencyTypeSelectOptions}
              size='small'
              fullWidth={true}
              buttonClassName='whitespace-nowrap'
            />
          </div> */}
        </div>
      </div>
      {designType == 'old' ? (
        <OldDesign
          homesData={homesData}
          selectedDiscount={selectedDiscount}
          priceForSquare={priceForSquare}
          terassaPriceForSquare={terassaPriceForSquare}
          handleChangePriceSquare={handleChangePriceSquare}
          handleChangeTerassaPriceSquare={handleChangeTerassaPriceSquare}
          currency={currency}
          sellPrice={sellPrice}
          handleChangeSellPrice={handleChangeSellPrice}
          isrepaired={isrepaired}
          handleChange={handleChange}
          discount={discount}
          discountPercentage={discountPercentage}
          homeData={homeData}
          startPriceTopOrder={startPriceTopOrder}
          handleChangeStartPriceOrder={handleChangeStartPriceOrder}
          startPricePercentage={startPricePercentage}
          handleChangeStartPricePercent={handleChangeStartPricePercent}
          startPrice={startPrice}
          handleChangeStartPrice={handleChangeStartPrice}
          month={month}
          handleChangeMonth={handleChangeMonth}
          setApplyDiscount={setApplyDiscount}
          applyDiscount={applyDiscount}
          formik={formik}
          fullPrice={fullPrice}
          handleChangeDiscount={handleChangeDiscount}
          handleChangeDiscountPercentage={handleChangeDiscountPercentage}
          priceForMonth={priceForMonth}
          isEnableCalc={isEnableCalc}
          setIsEnableCalc={setIsEnableCalc}
          percent={percent}
          setPercent={setPercent}
          calculations={calculations}
          setStartPrice={setStartPrice}
          setStartPricePercentage={setStartPricePercentage}
          setDiscount={setDiscount}
          setDiscountPercentage={setDiscountPercentage}
          setSellPrice={setSellPrice}
          setPriceForMonth={setPriceForMonth}
          setMonth={setMonth}
          setPriceForSquare={setPriceForSquare}
          setTerassaPriceForSquare={setTerassaPriceForSquare}
          setSelectedDiscount={setSelectedDiscount}
          setStartPriceTopOrder={setStartPriceTopOrder}
        />
      ) : (
        <NewDesign
          homesData={homesData}
          selectedDiscount={selectedDiscount}
          priceForSquare={priceForSquare}
          terassaPriceForSquare={terassaPriceForSquare}
          handleChangePriceSquare={handleChangePriceSquare}
          handleChangeTerassaPriceSquare={handleChangeTerassaPriceSquare}
          currency={currency}
          sellPrice={sellPrice}
          handleChangeSellPrice={handleChangeSellPrice}
          isrepaired={isrepaired}
          handleChange={handleChange}
          discount={discount}
          discountPercentage={discountPercentage}
          homeData={homeData}
          startPriceTopOrder={startPriceTopOrder}
          handleChangeStartPriceOrder={handleChangeStartPriceOrder}
          startPricePercentage={startPricePercentage}
          handleChangeStartPricePercent={handleChangeStartPricePercent}
          startPrice={startPrice}
          handleChangeStartPrice={handleChangeStartPrice}
          month={month}
          handleChangeMonth={handleChangeMonth}
          setApplyDiscount={setApplyDiscount}
          applyDiscount={applyDiscount}
          formik={formik}
          fullPrice={fullPrice}
          handleChangeDiscount={handleChangeDiscount}
          handleChangeDiscountPercentage={handleChangeDiscountPercentage}
          priceForMonth={priceForMonth}
          isEnableCalc={isEnableCalc}
          setIsEnableCalc={setIsEnableCalc}
          percent={percent}
          setPercent={setPercent}
          calculations={calculations}
          setStartPrice={setStartPrice}
          setStartPricePercentage={setStartPricePercentage}
          setDiscount={setDiscount}
          setDiscountPercentage={setDiscountPercentage}
          setSellPrice={setSellPrice}
          setPriceForMonth={setPriceForMonth}
          setMonth={setMonth}
          setPriceForSquare={setPriceForSquare}
          setTerassaPriceForSquare={setTerassaPriceForSquare}
          setSelectedDiscount={setSelectedDiscount}
          setStartPriceTopOrder={setStartPriceTopOrder}
          filters={filters}
          setFilters={setFilters}
        />
      )}
    </div>
  );
};
export default memo(CalculationByHomeData);
